import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DataParser from "../../../utlits/Dataparser";
import Sidebar from "../../Layouts/Sidebar";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "bootstrap-icons/font/bootstrap-icons.css";
import { FaUsers, FaUserCheck } from "react-icons/fa";
import { FaCakeCandles } from "react-icons/fa6";
import { RiTimeZoneFill } from "react-icons/ri";
import UserServices from "../../../Services/UserService";
import HolidayServices from "../../../Services/HolidayService";
import AttendanceServices from "../../../Services/AttendanceService";
import SocketService from "../../../Services/SocketService";
import { Tooltip } from "antd";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Home = () => {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [leaverequest, setLeaveRequest] = useState([]);
    const [AttendanceToday, setAttendanceToday] = useState([]);
    const [attendencesummary, setAttendanceSummary] = useState([]);
    const [holidays, setHolidays] = useState([]);

    const [graph, setGraph] = useState([]);
    const [options, setOptions] = useState({});

    const companyId = DataParser.CompanyId();

    useEffect(() => {

        UserServices.getUserSummary(companyId)
            .then((res) => {
                console.log("Raw API response:", res);

                if (res.Good) {
                    setUsers(res.data);
                } else {
                    console.warn("API returned Good=false or unexpected response:", res.data);
                }
            })
            .catch((err) => console.error("Error fetching users:", err));


        UserServices.getUserLeaveRequest(companyId)
            .then((res) => {
                console.log("Raw API response:", res);

                if (res.Good) {
                    setLeaveRequest(res.data);
                } else {
                    console.warn("API returned Good=false or unexpected response:", res.data);
                }
            })
            .catch((err) => console.error("Error fetching users:", err));

        UserServices.getUserHomeAttendence(companyId)
            .then((res) => {
                console.log("Raw API response:", res);

                if (res.Good) {
                    setAttendanceSummary(res.data);
                } else {
                    console.warn("API returned Good=false or unexpected response:", res.data);
                }
            })

        AttendanceServices.getAttendanceToday(companyId)
            .then((res) => {
                console.log("Raw API response Attendance:", res);

                if (res.Good) {
                    setAttendanceToday(res.data);
                } else {
                    console.warn("API returned Good=false or unexpected response:", res.data);
                }
            })
            .catch((err) => console.error("Error fetching holidays:", err));

    }, []);

    useEffect(() => {
        const handleAttendanceUpdate = (data) => {
            console.log("Socket: attendance_update received", data);
            if (String(data.company_id) === String(companyId)) {
                AttendanceServices.getAttendanceToday(companyId)
                    .then((res) => {
                        if (res.Good) setAttendanceToday(res.data);
                    })
                    .catch((err) => console.error("Error refreshing attendance:", err));

                UserServices.getUserHomeAttendence(companyId)
                    .then((res) => {
                        if (res.Good) setAttendanceSummary(res.data);
                    })
                    .catch((err) => console.error("Error refreshing attendance summary:", err));
            }
        };

        const handleLeaveUpdate = (data) => {
            console.log("Socket: leave_update received", data);
            if (String(data.company_id) === String(companyId)) {
                UserServices.getUserLeaveRequest(companyId)
                    .then((res) => {
                        if (res.Good) setLeaveRequest(res.data);
                    })
                    .catch((err) => console.error("Error refreshing leave requests:", err));
            }
        };

        const handleUserUpdate = (data) => {
            console.log("Socket: user_update received", data);
            if (String(data.company_id) === String(companyId)) {
                UserServices.getUserSummary(companyId)
                    .then((res) => {
                        if (res.Good) setUsers(res.data);
                    })
                    .catch((err) => console.error("Error refreshing user summary:", err));
            }
        };

        SocketService.on("attendance_update", handleAttendanceUpdate);
        SocketService.on("leave_update", handleLeaveUpdate);
        SocketService.on("user_update", handleUserUpdate);

        return () => {
            SocketService.off("attendance_update", handleAttendanceUpdate);
            SocketService.off("leave_update", handleLeaveUpdate);
            SocketService.off("user_update", handleUserUpdate);
        };
    }, [companyId]);


    useEffect(() => {
        UserServices.getUserHomeAttendenceGraph(companyId)
            .then((res) => {
                console.log("Raw API response:", res);

                if (res.Good && Array.isArray(res.data)) {
                    setGraph(res.data);

                    // âœ… API data se categories (days)
                    const categories = res.data.map((item) => item.day);

                    // âœ… Series ko API se dynamic banao
                    const series = [
                        {
                            name: "Present",
                            data: res.data.map((item) => item.Present || 0)
                        },
                        {
                            name: "Absent",
                            data: res.data.map((item) => item.Absent || 0)
                        },
                        {
                            name: "Leave",
                            data: res.data.map((item) => item.Leave || 0)
                        },
                        {
                            name: "WFH",
                            data: res.data.map((item) => item.WFH || 0)
                        }
                    ];

                    // âœ… Chart options update
                    setOptions({
                        chart: {
                            type: "spline",
                            backgroundColor: "transparent",
                            height: 400,
                            style: {
                                fontFamily: "Inter, sans-serif"
                            }
                        },
                        title: {
                            text: "Weekly Attendance Trend",
                            align: "left",
                            style: {
                                fontSize: "26px",
                                fontWeight: "bold"
                            }
                        },
                        xAxis: {
                            categories: categories, // âœ… API se days
                            lineColor: "#e5e5e5",
                            tickColor: "#e5e5e5",
                            endOnTick: true,
                            startOnTick: true,
                            minPadding: 0,
                            maxPadding: 0
                        },
                        yAxis: {
                            title: { text: null },
                            gridLineColor: "#f0f0f0",
                            tickInterval: 20,
                            min: 0
                        },
                        legend: {
                            align: "right",
                            verticalAlign: "top",
                            layout: "horizontal",
                            symbolHeight: 10,
                            symbolWidth: 10,
                            symbolRadius: 5,
                            itemStyle: {
                                fontWeight: "500",
                                fontSize: "15px"
                            },
                            useHTML: true,
                            labelFormatter: function () {
                                return `<span style="font-size:15px;">${this.name}</span>`;
                            }
                        },
                        plotOptions: {
                            series: {
                                marker: {
                                    enabled: true,
                                    radius: 5,
                                    symbol: "circle"
                                },
                                lineWidth: 2,
                                states: {
                                    hover: {
                                        enabled: true,
                                        lineWidth: 3
                                    }
                                },
                                events: {
                                    legendItemClick: function () {
                                        const chart = this.chart;
                                        setTimeout(() => chart.legend.render(), 0);
                                    }
                                }
                            }
                        },
                        colors: ["#00c49f", "#6a5acd", "#ffa500", "#0088fe"],
                        tooltip: {
                            shared: true,
                            backgroundColor: "#fff",
                            borderColor: "#ddd",
                            style: {
                                color: "#333"
                            }
                        },
                        series: series
                    });
                } else {
                    console.warn("API returned Good=false or unexpected response:", res.data);
                }
            })
            .catch((err) => console.error("Error fetching users:", err));
    }, [companyId]);



    return (
        <>
            {/* <Sidebar /> */}
            <div className="main-content">
                <div className="page-content Pagebody" style={{ background: "#fff", paddingBottom: 0, minHeight: "100vh" }}>

                    <div className="row gap-3 px-0">
                        {/* Total Employees */}
                        <div className="col d-flex px-0">
                            <div className="flex-fill custom-card border-0" style={{ borderRadius: "12px", backgroundColor: "#F7F8FA", boxShadow: "none" }}>
                                <div className="card-body p-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="icon-circle iconstyle p-0" style={{ backgroundColor: "#00DFAB", color: "#1D1D1D", width: "40px", height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <FaUsers size={20} />
                                        </div>
                                        <h6 className="card-title mb-0 ms-3 fw-semibold text-muted" style={{ fontSize: "14px" }}>Total Employees</h6>
                                    </div>
                                    <div className="d-flex align-items-center gap-3">
                                        <h2 className="mb-0 fw-bold" style={{ fontSize: "32px", color: "#1D1D1D" }}>{users.totalUsers}</h2>
                                        <div style={{ fontSize: "12px" }}>
                                            <div className="d-flex align-items-center gap-1 mb-1">
                                                <span className="dot active" style={{ width: "6px", height: "6px", borderRadius: "50%", background: "#4caf50" }}></span>
                                                <span className="text-muted">Active: {users.activeUsers}</span>
                                            </div>
                                            <div className="d-flex align-items-center gap-1">
                                                <span className="dot inactive" style={{ width: "6px", height: "6px", borderRadius: "50%", background: "#f44336" }}></span>
                                                <span className="text-muted">Inactive: {users.inactiveUsers}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Total Attendance */}
                        <div className="col d-flex px-0">
                            <div className="flex-fill custom-card border-0" style={{ borderRadius: "12px", backgroundColor: "#F7F8FA", boxShadow: "none" }}>
                                <div className="card-body p-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="icon-circle iconstyle p-0" style={{ backgroundColor: "#00DFAB", color: "#1D1D1D", width: "40px", height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <FaUserCheck size={18} />
                                        </div>
                                        <h6 className="card-title mb-0 ms-3 fw-semibold text-muted" style={{ fontSize: "14px" }}>Today's Attendance</h6>
                                    </div>
                                    <div className="row g-2 px-0">
                                        {attendencesummary.map((item, index) => (
                                            <div key={index} className="col-6 pe-3">
                                                <div className="d-flex align-items-center gap-1" style={{ fontSize: "12px" }}>
                                                    <span className={`dot ${item.label.toLowerCase()}`} style={{ width: "6px", height: "6px", borderRadius: "50%", background: item.label === "Present" ? "#4caf50" : item.label === "Absent" ? "#f44336" : "#2196f3" }}></span>
                                                    <span className="text-muted" style={{ whiteSpace: "nowrap" }}>{item.label}: {item.count}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Pending Leave Requests */}
                        <div className="col d-flex px-0">
                            <div className="flex-fill custom-card border-0" style={{ borderRadius: "12px", backgroundColor: "#F7F8FA", boxShadow: "none" }}>
                                <div className="card-body p-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="icon-circle iconstyle p-0" style={{ backgroundColor: "#00DFAB", color: "#1D1D1D", width: "40px", height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <RiTimeZoneFill size={20} />
                                        </div>
                                        <h6 className="card-title mb-0 ms-3 fw-semibold text-muted" style={{ fontSize: "14px" }}>Pending Leaves</h6>
                                    </div>
                                    <h2 className="mb-0 fw-bold" style={{ fontSize: "32px", color: "#1D1D1D" }}>{leaverequest.pendingLeavesCount || "00"}</h2>
                                </div>
                            </div>
                        </div>

                        {/* Upcoming Birthdays */}
                        <div className="col d-flex px-0">
                            <div className="flex-fill custom-card border-0" style={{ borderRadius: "12px", backgroundColor: "#F7F8FA", boxShadow: "none" }}>
                                <div className="card-body p-4">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="icon-circle iconstyle p-0" style={{ backgroundColor: "#00DFAB", color: "#1D1D1D", width: "40px", height: "40px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <FaCakeCandles size={18} />
                                        </div>
                                        <h6 className="card-title mb-0 ms-3 fw-semibold text-muted" style={{ fontSize: "14px" }}>Upcoming Birthdays</h6>
                                    </div>
                                    <Tooltip
                                        title={
                                            users.currentMonthBirthdaysList && users.currentMonthBirthdaysList.length > 0 ? (
                                                <div className="p-1">
                                                    {users.currentMonthBirthdaysList.map((b, i) => (
                                                        <div key={i} className="mb-1">
                                                            <strong>{b.full_name}</strong> - {b.dob}
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : "No birthdays this month"
                                        }
                                        color="#0bc698"
                                    >
                                        <h2 className="mb-0 fw-bold" style={{ fontSize: "32px", color: "#1D1D1D", cursor: "pointer" }}>
                                            {users.upcomingBirthdaysCount || "0"}
                                        </h2>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 px-0">
                        <div className="col-12 px-0">
                            <div className="flex-fill custom-card border-0 p-4" style={{ borderRadius: "12px", backgroundColor: "#F7F8FA", boxShadow: "none" }}>
                                {graph.length > 0 ? (
                                    <HighchartsReact highcharts={Highcharts} options={options} />
                                ) : (
                                    <Skeleton height={300} borderRadius={12} />
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="row gap-3 px-0 mt-3">
                        <div className="col d-flex px-0 ">
                            <div className="flex-fill custom-card border-0" style={{ borderRadius: "12px", backgroundColor: "#F7F8FA", boxShadow: "none" }}>
                                <div className="card-body p-4">
                                    <h5 className="fw-bold mb-4" style={{ fontSize: "16px" }}>Upcoming Holidays</h5>

                                    {holidays?.latestUpcomingHolidays?.length > 0 ? (
                                        <div className="d-flex flex-column gap-3">
                                            {holidays.latestUpcomingHolidays.map((event, index) => (
                                                <div
                                                    key={index}
                                                    className="d-flex justify-content-between align-items-center py-2 border-bottom border-light"
                                                >
                                                    <span className="fw-medium" style={{ fontSize: "14px" }}>{event.name}</span>
                                                    <span className="text-muted" style={{ fontSize: "13px" }}>{event.date}</span>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="text-center py-5 text-muted">No Upcoming Holidays</div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Upcoming Employees Holidays */}
                        <div className="col d-flex px-0 ">
                            <div className="flex-fill custom-card border-0" style={{ borderRadius: "12px", backgroundColor: "#F7F8FA", boxShadow: "none" }}>
                                <div className="card-body p-4">
                                    <h5 className="fw-bold mb-4" style={{ fontSize: "16px" }}>Upcoming Employee Birthdays</h5>

                                    {users.latestUpcomingBirthdays?.length > 0 ? (
                                        <div className="d-flex flex-column gap-3">
                                            {users.latestUpcomingBirthdays.map((holiday, index) => (
                                                <div
                                                    key={index}
                                                    className="d-flex justify-content-between align-items-center py-2 border-bottom border-light"
                                                >
                                                    <span className="fw-medium" style={{ fontSize: "14px" }}>{holiday.full_name}</span>
                                                    <span className="text-muted" style={{ fontSize: "13px" }}>{holiday.dob}</span>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="text-center py-5 text-muted">No Upcoming Birthdays</div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-5">
                        <div className="col-12 px-0">
                            <h5 className="fw-bold mb-3" style={{ fontSize: "16px" }}>Real Time Monitor</h5>
                            <div className="listing-table-wrapper">
                                <table className="table listing-table mb-0">
                                    <thead>
                                        <tr className="tableHeaderbg">
                                            <th className="text-center">ID</th>
                                            <th>Employee Name</th>
                                            <th>Department</th>
                                            <th className="text-center">Punched in</th>
                                            <th className="text-center">Punched out</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {AttendanceToday && AttendanceToday.length > 0 ? (
                                            AttendanceToday.map((item) => (
                                                <tr key={item.user_id}>
                                                    <td className="text-center">{item.user_id}</td>
                                                    <td className="fw-medium">{item.first_name} {item.last_name}</td>
                                                    <td>{item.department}</td>
                                                    <td className="text-center">{item.punch_in || "—"}</td>
                                                    <td className="text-center">{item.punch_out || "—"}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center py-5 text-muted">No attendance records found for today.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>

            </div>


        </>
    );
};

export default Home;
